/*
 * Ryan O'Dowd
 * 2025-05-26
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  useEffect,
  useRef,
} from 'react';
import {
  fetchProfilePictureUrl,
} from '@utils/store/actions';
import useTypedDispatch from './useTypedDispatch';
import useTypedSelector from './useTypedSelector';

export default function useGetPhotoUrl(username, forceRefresh=false) {
  const dispatch = useTypedDispatch();
  const photoUrl = useTypedSelector((state) => state.profilePictureUrls[username], (oldValue, newValue) => JSON.stringify(oldValue) === JSON.stringify(newValue));
  const missingPhoto = !photoUrl;

  const hasFetched = useRef(false);

  useEffect(() => {
    if (username && (forceRefresh || missingPhoto || photoUrl?.expiresAt < (Date.now() / 1000))) {
      if (!hasFetched.current) {
        dispatch(fetchProfilePictureUrl(username));
        hasFetched.current = true;
      }
    }
  }, [username, forceRefresh, missingPhoto, photoUrl?.expiresAt, dispatch]);

  return photoUrl?.url;
}
